import './assets/main.less'
import 'virtual:svg-icons-register'
import { createApp } from 'vue'
import { setupVant } from './vant'
import * as Sentry from '@sentry/vue'

// 初始化多语言
import { setupI18n } from '@/locales'

// 引入状态管理
import { setupStore } from '@/stores'

import App from './App.vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { setupRouter } from '@/router'

import registGlobaDirective from './directives'
import { registGlobalComponent } from './components'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import '@vant/touch-emulator'
import './utils/sa-sdk-javascript'

import './message'

// 动态加载 VConsole
if (import.meta.env.VITE_APP_ENV === 'test') {
  import('vconsole').then(VConsoleModule => {
    new VConsoleModule.default()
  })
}

Viewer.setDefaults({
  navbar: false,
  toolbar: {
    rotateLeft: true,
    rotateRight: true,
    zoomIn: true,
    zoomOut: true,
    oneToOne: false,
    reset: true,
    prev: false,
    next: false,
    play: false,
    fullscreen: false,
    thumb: false,
    download: false,
    toggleOn: false
  }
})

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  Sentry.init({
    app,
    debug: false,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(), // 性能追踪
      Sentry.replayIntegration({
        // 回放
        maskAllText: true, // 屏蔽文本
        blockAllMedia: true // 阻止回放媒体
      })
    ],
    ignoreErrors: [/Request failed with status code 401$/],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_APP_SOURCEMAP_RELEASE
  })

  await setupI18n(app)

  setupStore(app)

  setupRouter(app)

  setupVant(app)

  registGlobaDirective(app)
  registGlobalComponent(app)
  app.use(Viewer)
  app.use(FloatingVue)
  app.mount('#app')
}

setupAll()
